<template lang="pug">
.match-bet-area-type
  .match-bet-area-type-title {{ betType == 'hdp' ? $tc("m.BT_HDPF", 2) : $tc("m.BT_HDPH", 2) }}
  .match-odd-area
    .match-odd-area-oddtype
      p.mb-0 {{ $t("m.ODD_Home") }}
    template(v-if="Object.keys(details).length > 0 && details['tn'] > 0")
      template(v-for="(dn, i) in details['kns']")
        .match-odd-area-group
          template(v-if="details[betType] && details[betType][i] && details[betType][i][9] != 0 && details[betType][i][10] != 0 && details[betType][i][9] != '' && details[betType][i][10] != ''")
            oddsItemMMO(:odds="details[betType][i]" :idx="details[betType][i][7] == 1 ? '10' : '9'" :typ="oddsType" dataType="1" :mode="betType" :count="i" :details="details" homeAway="1" pos=22)
          template(v-else)
            OddsDisabled
    template(v-else)
      .match-odd-area-group
        OddsDisabled
    .match-odd-area-oddtype
      p.mb-0 {{ $t("m.ODD_Away") }}
    template(v-if="Object.keys(details).length > 0 && details['tn'] > 0")
      template(v-for="(dn, i) in details['kns']")
        .match-odd-area-group
          template(v-if="details[betType] && details[betType][i] && details[betType][i][9] != 0 && details[betType][i][10] != 0 && details[betType][i][9] != '' && details[betType][i][10] != ''")
            oddsItemMMO(:odds="details[betType][i]" :idx="details[betType][i][7] == 1 ? '9' : '10'" :typ="oddsType" dataType="1" :mode="betType" :count="i" :details="details" homeAway="2" pos=22)
          template(v-else)
            OddsDisabled
    template(v-else)
      .match-odd-area-group
        OddsDisabled
</template>

<script>
import oddsItemMMO from "@/components/mobile/main/xitem/oddsItemMMO";
import OddsDisabled from "@/components/mobile/main/xitem/oddsDisabled";

export default {
  components: {
    oddsItemMMO,
    OddsDisabled
  },
  props: {
    details: {
      type: Object
    },
    oddsType: {
      type: String
    },
    i: {
      type: [String, Number]
    },
    betType: {
      type: String
    },
    homeAway: {
      type: String
    }
  }
};
</script>